import React from "react";

import { Box, Input } from "@chakra-ui/react";
import { ReactComponent as CheckIcon } from "assets/icons/checkbox-icon.svg";

import { IStyledCheckboxProps } from "./types";

export const StyledCheckbox = (props: IStyledCheckboxProps) => {
  const { isChecked, handleCheckBoxChange, name, handleClick, disabled } =
    props;

  const handleChange = () => {
    const newCheckedState = !isChecked;
    handleCheckBoxChange(newCheckedState);
  };

  return (
    <label
      className={`inline-block relative ${disabled ? "cursor-not-allowed opacity-40" : "cursor-pointer"}`}
    >
      <Input
        checked={isChecked}
        onChange={disabled ? undefined : handleChange}
        type="checkbox"
        name={name}
        onClick={disabled ? undefined : handleClick}
        className="opacity-0 absolute w-0 h-0"
        disabled={disabled}
        readOnly={disabled}
      />
      <Box
        className="w-5 h-5 rounded-md flex items-center justify-center"
        css={{
          border: `1px solid ${isChecked ? "#00535C" : "#D0D5DD"}`,
          backgroundColor: isChecked ? "#E5FDFF" : "#FFFFFF",
          transition: "all 0.2s ease",
          cursor: disabled ? "not-allowed" : "pointer",

          "& svg": {
            display: isChecked ? "block" : "none",
          },
        }}
      >
        <CheckIcon />
      </Box>
    </label>
  );
};
